import { RouteObject } from 'react-router-dom';
import Dashboard from '../pages/dashboard/page';
import Jobs from '../pages/jobs/page';
import Projects from '../pages/projects/page';
import Profile from '../pages/profile/page';
import Auth from '../pages/auth/page';
import Splash from '../pages/splash/page';
import Attendance from '../pages/attendance/page';
import Payments from '../pages/payments/page';
import JobDetails from '../pages/job-details/page';
import ProjectDetails from '../pages/project-details/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Dashboard />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/jobs',
    element: <Jobs />
  },
  {
    path: '/jobs/:id',
    element: <JobDetails />
  },
  {
    path: '/projects',
    element: <Projects />
  },
  {
    path: '/projects/:id',
    element: <ProjectDetails />
  },
  {
    path: '/attendance',
    element: <Attendance />
  },
  {
    path: '/payments',
    element: <Payments />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/auth',
    element: <Auth />
  },
  {
    path: '/splash',
    element: <Splash />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
